import React from 'react';
import { observer } from 'mobx-react';
import { ConnectionGroupFormVM } from './connection-group-form.viewmodel';
import { CommonPopupBodyFooterLayout } from '../../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../../global/sub-window/common/common-close-sub-window-buttons';
import { CANCEL_TEXT, MORE_BUTTON_TEXT, submitText } from '../../../../../../constants/common-labels.constants';
import { ConnectionGroupFieldKey, FORM_CONFIG } from './connection-group-form.config';
import { FormFieldInput } from '../../../../../global/form/form-field-input/form-field-input';
import './connection-group-form.scss';
import { CONNECTION_GROUP_CONNECTIONS_LABEL_TEXT, DELETE_CONNECTION_GROUP_TEXT } from '../connection-groups.texts';
import { ConnectionGroupConnectionsList } from './connection-group-connections-list/connection-group-connections-list';
import { hasPermission } from '../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../api/roles.dao';
import OptionsButton from '../../../../../global/options-button/options-button';
import { FormattedMessage } from 'react-intl';
import { PassportDisplayHeader } from '../../configure-passport-display/passport-display-header';
import { ConnectionGroupPassportPreviewPopover } from '../connection-groups-passport-preview/connection-group-passport-preview-popover';

type ConnectionGroupFormPresentationProps = {
    vm: ConnectionGroupFormVM;
};

export const ConnectionGroupFormPresentation = observer((props: ConnectionGroupFormPresentationProps) => {
    const { vm } = props;
    const labelField = vm.getFormFieldPropsByKey(ConnectionGroupFieldKey.LABEL);
    const isEdit = vm.isEdit();
    const connectionGroupsPassportPreviewViewModel = vm.getConnectionGroupsPassportPreviewViewModel();

    const groupOptions = [
        hasPermission(Permission.DELETE_CONNECTION_GROUPS) && {
            label: vm.intl.formatMessage(DELETE_CONNECTION_GROUP_TEXT),
            action: () => vm.deleteConnectionGroup(vm.group.meetingConnectionId),
            danger: true
        }
    ].filter(Boolean);

    return (
        <CommonPopupBodyFooterLayout
            body={
                <>
                <PassportDisplayHeader
                    connectionLabel={connectionGroupsPassportPreviewViewModel.getPopoverTitle()}
                    onClickPreview={connectionGroupsPassportPreviewViewModel.openPopover}
                    disabled={connectionGroupsPassportPreviewViewModel.getIsPreviewDisabled()}
                />
                <form className='oe-form connection-group-form'>
                    <div className='oe-form__body'>
                        <FormFieldInput.Text field={labelField} labelDescriptor={FORM_CONFIG[ConnectionGroupFieldKey.LABEL].labelDescriptor} withError />
                        <div className='connection-group-form__connections'>
                            <div className='oe-form-field__title'>{vm.intl.formatMessage(CONNECTION_GROUP_CONNECTIONS_LABEL_TEXT)}</div>
                            <ConnectionGroupConnectionsList
                                enabledConnections={vm.getEnabledConnections()}
                                disabledConnections={vm.getDisabledConnections()}
                                enableConnection={vm.enableConnection}
                                disableConnection={vm.disableConnection}
                                onReorder={vm.setEnabledConnections}
                                maxEnabledConnections={vm.maxEnabledConnections}
                            />
                        </div>
                    </div>
                </form>
                <ConnectionGroupPassportPreviewPopover vm={connectionGroupsPassportPreviewViewModel} />
                </>
            }
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseSubWindowButton
                        text={submitText(isEdit)}
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.submitForm}
                        disabled={vm.isLoading}
                    />
                    <DefaultCloseSubWindowButton
                        text={vm.intl.formatMessage(CANCEL_TEXT)}
                    />
                    {isEdit && groupOptions.length > 0 &&
                        <OptionsButton
                            className='options-button--right-margin-auto'
                            modifier={['fat', 'options']}
                            label={<FormattedMessage {...MORE_BUTTON_TEXT} />}
                            options={groupOptions}
                            position='top'
                            align='start'
                        />
                    }
                </div>
            }
        />
    );
});
